import { render, staticRenderFns } from "./accountMenu.vue?vue&type=template&id=36062996&scoped=true"
import script from "./accountMenu.vue?vue&type=script&lang=js"
export * from "./accountMenu.vue?vue&type=script&lang=js"
import style0 from "./accountMenu.vue?vue&type=style&index=0&id=36062996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36062996",
  null
  
)

export default component.exports